/**
 * useSearchableList
 */

import { useApi2 } from 'containers/Api2/index.js';
import searchFilter from 'components/interaction/Search/searchFilter.js';
import { idValues } from 'utils/arrays.js';

const PAGESIZE = 10;

function useSearchableList(options) {
  const { url, search, clientSearch, limit = 9999, pageSize = PAGESIZE, ...rest } = options;

  const q = (search && !clientSearch) ? `q=${encodeURIComponent(search)}&` : '';
  const ch = url.includes('?') ? '&' : '?';
  const items = useApi2({
    url: `${url}${ch}${q}offset=0&limit=${clientSearch ? limit : pageSize}`,
    ...rest,
  });

  const filter = searchFilter(search, ['name', 'displayName', 'adminName', 'systemName']);
  const list = clientSearch ? filter(idValues(items)) : idValues(items);
  return { items, list };
}

export default useSearchableList;
